import iconMark from '../assets/image/marker.svg';
import iconLoading from '../assets/image/loading.svg';

const images = {
    iconMark,
    iconLoading,
};

export default images;
